import {
	newSubmission,
	submissionByID,
	submissionDestroy,
	submissionList,
	updateSubmission,
} from '@/services/jobs/salarySubmissions.service'

export default {
	namespaced: true,
	state: {
		// SUBMISSION
		submissionList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},

		submission: {},

		// STATUS
		submissionStatus: 'init',
		submissionSaveStatus: 'init',
		submissionDeleteStatus: 'init',
	},
	getters: {
		// SUBMISSIONS
		getSubmissionList(state) {
			return state.submissionList
		},
		getSubmission(state) {
			return state.submission
		},

		// STATUS
		getSubmissionDeleteStatus(state) {
			return state.submissionDeleteStatus
		},
		getSubmissionSaveStatus(state) {
			return state.submissionSaveStatus
		},
		getSubmissionStatus(state) {
			return state.submissionStatus
		},
	},
	mutations: {
		// SUBMISSION
		SUBMISSION_LIST(state, value) {
			state.submissionList = value
		},
		SET_SUBMISSION(state, value) {
			state.submission = value
		},

		// STATUS
		SUBMISSION_STATUS(state, value) {
			state.submissionStatus = value
		},
		SUBMISSION_SAVE_STATUS(state, value) {
			state.submissionSaveStatus = value
		},
		SUBMISSION_DELETE_STATUS(state, value) {
			state.submissionDeleteStatus = value
		},
	},
	actions: {
		// SUBMISSION
		async getSubmissionList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('SUBMISSION_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			commit('SUBMISSION_STATUS', 'pending')
			try {
				const { data } = await submissionList(params)
				commit('SUBMISSION_STATUS', 'init')
				commit('SUBMISSION_LIST', data)
				return data
			} catch (error) {
				commit('SUBMISSION_STATUS', 'init')
				throw error
			}
		},
		async deleSubmissionByID({ commit }, params) {
			commit('SUBMISSION_DELETE_STATUS', 'pending')
			try {
				const { data } = await submissionDestroy(params)
				commit('SUBMISSION_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SUBMISSION_DELETE_STATUS', 'init')
				this._vm.$root.$notify({
					message: error.response.data.message,
					type: 'danger',
				})
				return error
			}
		},
		async updateSubmission({ commit }, params) {
			commit('SUBMISSION_SAVE_STATUS', 'pending')
			try {
				const { data } = await updateSubmission(params)
				commit('SUBMISSION_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SUBMISSION_SAVE_STATUS', 'init')
				throw error
			}
		},
		async fetchSubmissionByID({ state, commit }, params) {
			commit('SUBMISSION_STATUS', 'pending')
			try {
				const { data } = await submissionByID(params)
				commit('SUBMISSION_STATUS', 'init')
				commit('SET_SUBMISSION', data.data)
				return data
			} catch (error) {
				commit('SUBMISSION_STATUS', 'init')
				this._vm.$root.$notify({
					message: error.response.data.message,
					type: 'danger',
				})
				return error
			}
		},
		async saveNewSubmission({ commit }, params) {
			commit('SUBMISSION_SAVE_STATUS', 'pending')
			try {
				const { data } = await newSubmission(params)
				commit('SUBMISSION_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SUBMISSION_SAVE_STATUS', 'init')
				throw error
			}
		},
	},
}
